<template>
  <div>
    <el-form :model="formData" :inline="true" size="mini">
      <!-- <el-form-item label="品类">
        <el-select v-model="formData.category" @change="handleCategoryChange">
          <el-option :label="item" :value="item" v-for="(item,index) in categorys" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="材质" v-if="materials.length">
        <el-select v-model="formData.material" @change="updateFormData">
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in materials" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="颜色" v-if="colors.length">
        <el-select v-model="formData.color" @change="updateFormData">
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in colors" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="尺寸" v-if="lengths.length">
        <el-select v-model="formData.length" @change="updateFormData">
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in lengths" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="价格" v-if="prices.length">
        <el-select v-model="formData.price" @change="updateFormData">
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.optionDesc" :value="item.optionValue" v-for="(item,index) in prices" :key="index"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const maps = {
  'materials': 1,
  'colors': 2,
  'lengths': 3,
  'prices': 4
}
export default {
  data() {
    return {
      formData: {
        category: '',
        color: '',
        length: '',
        material: '',
        price: '',
      },
      categorys: [],
      colors: [],
      lengths: [],
      materials: [],
      prices: [],
      categoryName: '沙发'
    }
  },
  mounted() {
    this.get_categoryOpt();
  },
  methods: {
    updateFormData() {
      this.$emit('change', {
        formData: this.formData,
        anotherOpt: {
          colors: this.colors,
          lengths: this.lengths,
          materials: this.materials,
          prices: this.prices
        }
      })
    },
    get_categoryOpt() {
      this.$q.goodsAnalysis.categorySelect()
      .then(res=>{
        this.categorys = res.data || [];
        // 默认显示 沙发
        this.handleCategoryChange(this.categoryName);
      })
    },
    async handleCategoryChange(data) {
      this.formData.category = data;
      this.formData['color'] = '';
      this.formData['length'] = '';
      this.formData['material'] = '';
      this.formData['price'] = '';
      await this.get_anotherOpt();
      this.updateFormData();
    },
    async handleOptionChange({key, name}) {
      this.formData[key] = this[key+'s'].find(v=>v.optionDesc == name).optionValue
      this.updateFormData();
    },
    get_anotherOpt() {
      return this.$q.goodsAnalysis.categoryAttr({fragment: [this.formData.category]})
      .then(res=>{
        Object.keys(maps).forEach(key=>{
          this.$set(this, key, res.data[maps[key]] || []);
        })
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
  >>> .el-form-item
    margin-bottom 0 !important
</style>